export default {
  root: {
    minWidth: 340,
  },
};
